import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { LinesManageButtonSignal } from '../Types/Types';
import { RootState } from '../redux/store';

/**
 * Custom hook to handle button clicks from the `PurchaseMoreLessButtons` component.
 *
 * @param handleClick Callback function that receives a `buttonSignal` argument:
 *   - `MORE_LINES_SIGNAL` (equal to `1`) when the "More lines" button is clicked.
 *   - `FEWER_LINES_SIGNAL` (equal to `-1`) when the "Fewer lines" button is clicked.
 */
function useLinesManageButtonClick(handleClick: (buttonSignal: LinesManageButtonSignal) => void) {
    const isFirstRender = useRef(true);
    const { linesManageButtonSignal } = useSelector((state: RootState) => state.playStore);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!linesManageButtonSignal.value) {
            return;
        }
        handleClick(linesManageButtonSignal.value);
    }, [linesManageButtonSignal]);
}

export default useLinesManageButtonClick;
